import React from 'react';
import {Stack} from '@mui/material';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {useQueryParams} from 'presentation/pages/private/hooks';

import {getSpecialtyBySearch} from 'presentation/utils/GetSpecialtyBySearch';
import {FlowEnum} from '../../constants';
import {MostSearchedCard} from '../MostSearchedCard';
import {StyledSpecialtiesGrid, StyledTypography} from './styles';

import {MostSearchedListProps} from './types';
import {MOST_SEARCHED} from 'presentation/modules/booking/shared/constants/mostSearched';
import {textHandle} from 'presentation/utils/textHandle';

const {mostSearched} = translations['pt-br'].privateFlow.bookingFlow.specialtyFlow;

export function MostSearchedList({
	flowType,
	mostSearchedArr,
	handleSelectCard,
}: MostSearchedListProps) {
	const {SEARCH_PARAMS} = useQueryParams();
	const {query, searchByLetter} = SEARCH_PARAMS;

	const isExam = flowType === FlowEnum.EXAM;

	if (isExam || mostSearchedArr?.length === 0) {
		return null;
	}

	const sanitizedQuery = query ? textHandle(query).sanitizeText() : '';
	const specialtySearchTerm = query ? getSpecialtyBySearch({text: sanitizedQuery, flowType}) : '';

	const filteredMostSearched = (mostSearchedArr || []).filter(specialty => {
		const formattedText = textHandle(specialty?.formattedText).sanitizeText();
		const matchesQuery = query ? formattedText?.includes(specialtySearchTerm) : true;
		const matchesLetter = searchByLetter
			? formattedText?.startsWith(searchByLetter?.toLowerCase()) ||
				(['d', 'n'].includes(searchByLetter?.toLowerCase()) &&
					specialty?.code === MOST_SEARCHED?.headache?.code)
			: true;

		return matchesQuery && matchesLetter;
	});

	if (filteredMostSearched?.length === 0) {
		return null;
	}

	return filteredMostSearched.length > 0 ? (
		<Stack mt={2} gap={2}>
			<StyledTypography variant="subheader">{mostSearched}</StyledTypography>
			<StyledSpecialtiesGrid>
				{filteredMostSearched?.map((specialty, index) => (
					<MostSearchedCard
						key={index}
						dataTagId={AppointmentBookingEnum.SELECIONOU_ESPECIALIDADE_MAIS_PROCURADA}
						text={formatText(specialty?.formattedText)}
						handleClick={() => handleSelectCard(specialty)}
						selected={false}
						specialtyCode={specialty.code}
						showSpecialtyDetailsButton={specialty.hasDefinition}
					/>
				))}
			</StyledSpecialtiesGrid>
		</Stack>
	) : null;
}
